<template>
  <div>
    <div class="card card-custom card-stretch gutter-b mb-0 pb-5">
      <div class="card-header border-0 py-1 pr-4 pl-4 pt-3">
        <div class="card-title">
          <h3 class="card-label text-white font-weight-bolder">Peta Capaian</h3>
        </div>
        <div class="card-toolbar">
          <span class="h5 pt-3 text-white">Tampilkan Sekolah: &nbsp;</span>
          <toggle-switch
            :options="switchOptions"
            :value="selectedToggle"
            @change="updateToggle($event.value)"
            class="mt-2"
          />
        </div>
      </div>
      <div class="card-body pr-0 pl-0 pt-0 pb-0">
        <l-map
          :center="center"
          :zoom="zoom"
          style="height: 500px; background-color: #75cff0"
          :options="mapOptions"
          ref="mainMap"
          @leaflet:load="setMapReady(true)"
        >
          <l-choropleth-layer
            :data="districtData"
            titleKey="kabupaten"
            idKey="id_kabupaten"
            :value="value"
            geojsonIdKey="ADM2_PCODE"
            :geojson="geojson"
            :colorScale="colorScale"
          >
            <template slot-scope="props">
              <l-info-control
                :item="props.currentItem"
                :unit="props.unit"
                title="Kepatuhan 3M Sekolah"
                :subTitle="getSubTitle"
                placeholder="Hover over a region"
                position="topright"
              />
              <l-reference-chart
                title="Kepatuhan 3M Sekolah"
                :colorScale="colorScale"
                :min="props.min"
                :max="props.max"
                position="bottomright"
              />
            </template>
          </l-choropleth-layer>
          <!-- <LTileLayer :url="url" :attribution="attribution" /> -->
          <CanvasMarker :markers="markers" />
        </l-map>
      </div>
    </div>
  </div>
</template>

<script>
import L from 'leaflet'
import { mapGetters } from 'vuex'
import { getDotColor, getPercentage } from '@/core/helpers/util.js'
import ReferenceChart from '@/view/components/map/ReferenceChart.vue'
import InfoControl from '@/view/components/map/InfoControl.vue'
import ChoroplethLayer from '@/view/components/map/ChoroplethLayer.vue'

import { LMap, LTileLayer } from 'vue2-leaflet'
// https://github.com/Simerca/vue2-leaflet-canvas-marker
import CanvasMarker from '@/view/components/map/CanvasMarker.vue'
import ToggleSwitch from 'vuejs-toggle-switch'

export default {
  name: 'map_container',
  props: {
    tigaMData: null,
    districtData: null,
    geojson: Object,
    zoom: null,
    center: null,
  },
  components: {
    LMap,
    'l-info-control': InfoControl,
    'l-reference-chart': ReferenceChart,
    'l-choropleth-layer': ChoroplethLayer,
    LTileLayer,
    CanvasMarker,
    ToggleSwitch, // toggle
  },
  data() {
    return {
      defaultBounds: null,
      isMapReady: false,
      colorScale: ['e7d090', 'e9ae7b', 'de7062'],
      // colorScale: ['D27DFF', '8737B4', '3E006D'],
      value: {
        key: 'value',
        metric: '',
      },
      mapOptions: {
        attributionControl: false,
        scrollWheelZoom: false,
      },
      url: 'https://api.mapbox.com/styles/v1/mapbox/outdoors-v11/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoibWFwYm94IiwiYSI6ImNpejY4NXVycTA2emYycXBndHRqcmZ3N3gifQ.rJcFIG214AriISLbB6B5aw',
      attribution:
        'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, ' +
        '<a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, ' +
        'Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',

      // toggle
      selectedToggle: 'Ya',
      switchOptions: {
        layout: {
          color: '#3F4254',
          backgroundColor: 'white',
          selectedColor: 'white',
          selectedBackgroundColor: '#3699ff',
          borderColor: '#5FA6C1',
          fontFamily: 'Arial',
          fontWeight: 'normal',
          fontWeightSelected: 'bold',
          squareCorners: false,
          noBorder: false,
        },
        size: {
          fontSize: 1,
          height: 2.5,
          width: 10,
        },
        items: {
          delay: 0.4,
          preSelected: 'unknown',
          disabled: false,
          labels: [
            { name: 'Ya', color: 'white', backgroundColor: '#3699ff' },
            { name: 'Tidak', color: 'white', backgroundColor: '#f64e60' },
          ],
        },
      },
    }
  },
  mounted() {
    this.$refs.mainMap.mapObject.getContainer().childNodes[2].childNodes[1].style.display =
      'none'

    // triggered from other children (TabWidget)
    this.$root.$on('centerMe', (data) => {
      console.log(data)
      this.setCenter()
    })
  },
  methods: {
    setMapReady() {
      console.log('map ready')
      this.isMapReady = true
      // this.$refs.mainMap.mapObject.createPane('zioPane')
      this.defaultBounds = this.$refs.mainMap.mapObject.getBounds()
    },
    // toggle
    updateToggle($event) {
      console.log(this.$refs.mainMap.mapObject.getPanes())
      if (this.selectedToggle === 'Ya') {
        this.$refs.mainMap.mapObject.getPane('markerPane').style.display =
          'none'
        this.$refs.mainMap.mapObject.getPane('popupPane').style.display = 'none'
        this.$refs.mainMap.mapObject.getContainer().childNodes[3].childNodes[1].style.display =
          ''
      } else {
        this.$refs.mainMap.mapObject.getPane('markerPane').style.display = ''
        this.$refs.mainMap.mapObject.getPane('popupPane').style.display = ''
        this.$refs.mainMap.mapObject.getContainer().childNodes[3].childNodes[1].style.display =
          'none'
      }

      this.selectedToggle = $event
    },
    setCenter() {
      this.$refs.mainMap.mapObject.fitBounds(this.defaultBounds)
    },
  },
  computed: {
    ...mapGetters(['getTab']),
    getSubTitle() {
      if (this.getTab) {
        let title
        switch (this.getTab) {
          case 2:
            title = 'Memakai Masker'
            break
          case 3:
            title = 'Menjaga Jarak'
            break
          default:
            title = 'Mencuci Tangan'
        }
        return title
      }
      return false
    },
    markers() {
      let markers = []
      const baseUrl = process.env.VUE_APP_BASE_URL

      for (var i = 0; i < this.tigaMData.length; i++) {
        if (this.tigaMData[i]['lat'] && this.tigaMData[i]['lng']) {
          let lat = this.tigaMData[i]['lat']
          let lng = this.tigaMData[i]['lng']
          var icon = L.icon({
            iconUrl: `${baseUrl}/media/map/assets/${getDotColor(
              this.tigaMData[i]['value']
            )}.png`,
            iconSize: [8, 8],
            iconAnchor: [4, 4],
          })
          markers.push(
            L.marker([lat, lng], { icon: icon }).bindPopup(
              `Cakupan kepatuhan 
              <span class="text-primary font-weight-bolder">${
                this.getSubTitle
              }</span> di<br />  
              <span class="font-weight-bolder">
              ${this.tigaMData[i]['name']}
              </span><br /> 
              <b class="text-primary">${getPercentage(
                this.tigaMData[i]['value'],
                10
              )}%</b`
            )
          )
        }
      }
      return markers
    },
  },
}
</script>

<style lang="scss" scoped>
.card {
  border-radius: 0.3rem;
}
.card-custom {
  background-color: #75cff0;
}
</style>
